/** Pixen Intrigue — overridden layout copy (courtly-fae voice). */
export const layoutPixEn = {
  'layout.nav.veil': 'The Court',
  'layout.nav.enter': 'Present Yourself at {world}',
  'layout.footer.tagline':
    'A glittering, treacherous court of the fae, where every whisper is currency and every smile a blade.',
}
